import { render, staticRenderFns } from "./RenameCollectionBtnDialog.vue?vue&type=template&id=158dd02d&scoped=true"
import script from "./RenameCollectionBtnDialog.vue?vue&type=script&lang=js"
export * from "./RenameCollectionBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158dd02d",
  null
  
)

export default component.exports